// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.divGroupAdminUser {\n  margin-top: 2%;\n  margin-left: 5%;\n  margin-right: 15%;\n  width: 80%;\n}\n#tblGroupAdminUser table {\n  width: 100%;\n  row-gap: 50px;\n}\n#tblGroupAdminUser tr {\n  width: 100%;\n}\n#tblGroupAdminUser td {\n  line-height: 41px;\n  width: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
